/*
 * Purpose : Common component for loading spinner modal
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'

const loadingModal = (props) => {
    return (
        <Modal isOpen={props.open} centered={true} > 
                <ModalHeader style={{backgroundColor:"#FB8734"}}><font color="#FFFFFF" >Please wait.!</font></ModalHeader>
                <ModalBody>
                    <div style={{color:"rgb(251, 135, 52)", textAlign:"center"}}>
                        <span>
                            <i style={{ fontSize:"30px" }} className="fa fa-spinner fa-spin"></i>
                            {props.msg}
                        </span>
                    </div>
                </ModalBody>
        </Modal>
    )
}
export default loadingModal
